import React, { useEffect } from "react";
import { Col, Container, Row, Form, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { BsArrowClockwise } from "react-icons/bs";

const ROAD_SAFETY_KPI = ({data, changeValues, showModalCal, filter}) => {

    const { setValues, values, calculoPromedio, calculoTrafficRoadS } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        
        const datas = {
            safety: {
                total_traffic_crashes_serious_inj_pop: calculoTrafficRoadS('population'), 
                total_traffic_crashes_serious_inj_vehi: calculoTrafficRoadS('fleet_size'),
                seriously_injured: "",
                fatalities: "",
                causa_acc: {
                    cause_acc_alcohol_per: calculoPromedio('cause_acc_alcohol_per'),
                    cause_acc_speed_per: calculoPromedio('cause_acc_speed_per'),
                    cause_acc_infrastructure_per: calculoPromedio('cause_acc_infrastructure_per'),
                    cause_acc_electronic_dev_per: calculoPromedio('cause_acc_electronic_dev_per'),
                    cause_acc_veh_corres_stadards_per: calculoPromedio('cause_acc_veh_corres_stadards_per')
                },
                cause_accidentsPcg: {
                    cause_acc_alcohol_per: calculoPromedio('cause_acc_alcohol_per'),
                    cause_acc_speed_per: calculoPromedio('cause_acc_speed_per'),
                    cause_acc_infrastructure_per: calculoPromedio('cause_acc_infrastructure_per'),
                    cause_acc_electronic_dev_per: calculoPromedio('cause_acc_electronic_dev_per'),
                    cause_acc_veh_corres_stadards_per: calculoPromedio('cause_acc_veh_corres_stadards_per')
                }
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="safety" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="safety" title="Safety" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="safety.total_traffic_crashes_serious_inj_pop" label="Road Traffic Crashes Compared to Population" name="safety.total_traffic_crashes_serious_inj_pop" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="safety.total_traffic_crashes_serious_inj_vehi" label="Road Traffic Crashes Compared to Vehicle Fleet" name="safety.total_traffic_crashes_serious_inj_vehi" disabled={true}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="safety.seriously_injured" label="Seriously Injured" name="safety.seriously_injured" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.seriously_injured", "seriously_injured")}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="safety.fatalities" label="Fatalities" name="safety.fatalities" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.fatalities", "fatalities")}/>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Cause of Accidents</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.causa_acc.cause_acc_alcohol_per" label="Alcohol (%)" name="safety.causa_acc.cause_acc_alcohol_per" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.causa_acc.cause_acc_speed_per" label="Speed (%)" name="safety.causa_acc.cause_acc_speed_per" disabled={true}/>
                                </Col>
                                
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.causa_acc.cause_acc_infrastructure_per" label="Infraestructure (%)" name="safety.causa_acc.cause_acc_infrastructure_per" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.causa_acc.cause_acc_electronic_dev_per" label="Use of electronic devices (mobile phone, GPS, etc) (%)" name="safety.causa_acc.cause_acc_electronic_dev_per" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="safety.causa_acc.cause_acc_veh_corres_stadards_per" label="Vehicle not corresponding to standard" name="safety.causa_acc.cause_acc_veh_corres_stadards_per" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Cause of Accidents (% change)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.cause_accidentsPcg.cause_acc_alcohol_per" label="Alcohol (%)" name="safety.cause_accidentsPcg.cause_acc_alcohol_per" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.cause_accidentsPcg.cause_acc_alcohol_per", "cause_acc_alcohol_per")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.cause_accidentsPcg.cause_acc_speed_per" label="Speed (%)" name="safety.cause_accidentsPcg.cause_acc_speed_per" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.cause_accidentsPcg.cause_acc_speed_per", "cause_acc_speed_per")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.cause_accidentsPcg.cause_acc_infrastructure_per" label="Infraestructure (%)" name="safety.cause_accidentsPcg.cause_acc_infrastructure_per" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.cause_accidentsPcg.cause_acc_infrastructure_per", "cause_acc_infrastructure_per")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.cause_accidentsPcg.cause_acc_electronic_dev_per" label="Use of electronic devices (mobile phone, GPS, etc) (%)" name="safety.cause_accidentsPcg.cause_acc_electronic_dev_per" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.cause_accidentsPcg.cause_acc_electronic_dev_per", "cause_acc_electronic_dev_per")}/>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="safety.cause_accidentsPcg.cause_acc_veh_corres_stadards_per" label="Vehicle not corresponding to standard" name="safety.cause_accidentsPcg.cause_acc_veh_corres_stadards_per" disabled={true}/>
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCal("safety.cause_accidentsPcg.cause_acc_veh_corres_stadards_per", "cause_acc_veh_corres_stadards_per")}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default ROAD_SAFETY_KPI;